import { Routes, RouterModule } from '@angular/router';
import { TasksComponent } from './tasks.component';
import { NgModule } from '@angular/core';


const routes: Routes = [
  { path: '', component: TasksComponent },
  { path: ':id', component: TasksComponent },
  { path: 'tasks/:pluginName', component: TasksComponent },
  { path: 'tasks/:customerId', component: TasksComponent },
  { path: 'tasks/:laboratoryId/:status/:startDate/:endDate',component: TasksComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TasksRoutingModule { }
